import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as staticDataReducer from '../static-data.reducer';
import * as avcFrequenciesReducer from '../reducers/avc-frequencies.reducer';

export const selectAVCFrequencies = createSelector(staticDataReducer.selectAVCFrequenciesState, avcFrequenciesReducer.getAVCFrequencies);
